// @flow
import { Record } from 'immutable';
import type { RecordOf, RecordFactory } from 'immutable';

type AlertsProps = {
  id: string,
  type: ?string,
  title: ?string,
  inputVariables: ?Object,
  inputValues: ?Object,
  preferences: ?Object,
}
export type Alerts = RecordOf<AlertsProps>;

export const mkAlerts: RecordFactory<AlertsProps> =
  Record({
    id: '',
    type: undefined,
    title: undefined,
    inputVariables: undefined,
    inputValues: undefined,
    preferences: undefined,
  });
